export default __webpack_public_path__ + "static/social-0ab95b5a7f3b187ff2420e8658f6e794.png";